import type { Distance, Point } from "@pdfking/math"
import { DrawPath } from "@pdfking/renderer-api"

import type { FolderPath } from "#public"

/** A straight cut or fold from `a` to `b`. */
export const FolderLine = (a: Point<Distance>, b: Point<Distance>): FolderPath => ({
  points: DrawPath([a, b]),
  closed: false,
})
